"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateValuePerMetrics = exports.calculateTotalPerUnit = exports.calculateTotalPerArea = void 0;
const area_1 = require("@project-rouge/service-core/data/area");
const number_1 = require("@project-rouge/service-core/data/number");
/**
 * Calculate the "per area" cost of the given {@link total}.
 */
const calculateTotalPerArea = (total, area) => {
    return (0, number_1.toPrecision)(total / area, 2);
};
exports.calculateTotalPerArea = calculateTotalPerArea;
/**
 * Calculate the "per unit" cost of the given {@link total}.
 */
const calculateTotalPerUnit = (total, units) => {
    return (0, number_1.toPrecision)(total / units, 2);
};
exports.calculateTotalPerUnit = calculateTotalPerUnit;
/**
 * Calculate the {@link ValuePerMetric} from given inputs.
 */
const calculateValuePerMetrics = (total, units, sqm) => {
    return {
        unit: (0, exports.calculateTotalPerUnit)(total, units),
        sqm: (0, exports.calculateTotalPerArea)(total, sqm),
        sqft: (0, exports.calculateTotalPerArea)(total, (0, area_1.toSquareFoot)(sqm)),
    };
};
exports.calculateValuePerMetrics = calculateValuePerMetrics;
